import { render, staticRenderFns } from "./odoo-purchase-order-invoice-status-select.vue?vue&type=template&id=26f6d847&scoped=true&"
import script from "./odoo-purchase-order-invoice-status-select.vue?vue&type=script&lang=js&"
export * from "./odoo-purchase-order-invoice-status-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f6d847",
  null
  
)

export default component.exports